/**
 * @generated SignedSource<<755776f5caed9087e3e884068d0d5ded>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getDrawingSetVersionQuery$variables = {
  id: string;
};
export type getDrawingSetVersionQuery$data = {
  readonly drawingSetVersion: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetVersionFragment">;
  } | null | undefined;
};
export type getDrawingSetVersionQuery = {
  response: getDrawingSetVersionQuery$data;
  variables: getDrawingSetVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetVersion",
        "kind": "LinkedField",
        "name": "drawingSetVersion",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetVersionFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetVersion",
        "kind": "LinkedField",
        "name": "drawingSetVersion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "versionDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c28d33681b66d49b3b25dc55bab0f083",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetVersionQuery",
    "operationKind": "query",
    "text": "query getDrawingSetVersionQuery(\n  $id: ID!\n) {\n  drawingSetVersion(id: $id) {\n    ...drawingSetVersionFragment\n    id\n  }\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n"
  }
};
})();

(node as any).hash = "a0af229c4912bfd9b60008e67631e66c";

export default node;
